<template>
  <v-card rounded="0" class="actions__item">
    <v-card-title class="actions__title primary white--text">
      <span class="actions__status">
        <v-chip
          class="actions__status-chip"
          :color="getStatusColor"
          outlined
          x-small
        >
          <span class="actions__status-dot" :class="item.status"/>
            {{item.status_label}}
        </v-chip>
      </span>
      <span class="actions__title-text">{{ item.title }}</span>
    </v-card-title>
    <v-card-text class="py-3 flex-grow-1">
      <div class="actions__desc-wrap" v-if="item.profile_sales.length">
        <div class="actions__desc">
          {{ item.short_description }}
        </div>
        <div class="actions__bonuses">
          <div class="actions__bonus" v-for="sale in item.profile_sales" :key="sale.id">
            {{sale.bonuses}} баллов.<br>Дата выплаты: {{sale.paid_day}}
          </div>
        </div>
      </div>
      <template v-else>{{ item.short_description }}</template>
    </v-card-text>
    <v-card-actions class="px-3 actions__btn-bottom d-block">
      <div class="buttons-wrap">
        <div class="buttons-wrap--button" v-if="item.pdf_file_url">
          <v-btn
            color="secondary2"
            class="actions__btn"
            @click="showPDF(item.pdf_file_url)"
            block
          >Правила
          </v-btn>
        </div>
        <div class="buttons-wrap--button" v-if="item.pdf_detail_file_url">
          <v-btn
            color="secondary2"
            class="actions__btn"
            @click="showPDF(item.pdf_detail_file_url)"
            block
          >Список товаров
          </v-btn>
        </div>
        <div class="buttons-wrap--button">
          <v-btn
            color="secondary2"
            class="actions__btn"
            @click="showDesc(item.id)"
            block
          >
            Описание
            <font-awesome-icon
              v-if="showDescID && (showDescID === item.id)"
              icon="chevron-up"
              class=" size-18 btn-icon"
            />
            <font-awesome-icon
              v-else
              icon="chevron-down"
              class=" size-18 btn-icon"
            />
          </v-btn>
        </div>
      </div>
      <v-row>
        <v-col cols="12" sm="12" class="actions__btn-left">

          <div
            v-if="showDescID && (showDescID === item.id) && item.description"
            class="py-2 actions__description"
            v-html="item.description"
          />
        </v-col>
        <v-col cols="12" sm="12" class="actions__btn-left">
          <v-btn
            v-if="showActionPhotos && type !== 'archive'"
            @click="goToDetails"
            block
            color="primary"
            class="actions__btn mb-6"
          >
            {{isNeedSales ? 'Добавить фото' : 'Подтвердить закупку'}}
            <font-awesome-icon
              icon="file-image"
              class="size-18 ml-2 actions__btn-icon"
              block
            />
          </v-btn>
          <v-btn
            v-if="showActionProgress"
            @click="onTableShow"
            block
            color="primary"
            class="actions__btn"
          >
            Ход Акции
            <font-awesome-icon
              icon="plus-circle"
              class="size-18 ml-2 actions__btn-icon"
              block
            />
          </v-btn>
          <Table :item="item" v-if="item.original_sales_table && isTableShow"/>
          <div class="actions__table-desc pt-3" v-if="isTableDescShow">
            Данные по акции в процессе обработки
          </div>
          <v-btn
            v-if="canConfirm"
            @click="confirmAction(item.id)"
            color="primary"
            class="actions__btn"
            block
          >
            Подтвердить участие
            <font-awesome-icon
              icon="check-circle"
              class="size-18 ml-2 actions__btn-icon"
              block
            />
          </v-btn>
        </v-col>
      </v-row>
    </v-card-actions>
  </v-card>
</template>

<script>
import Table from './Table.vue';

export default {
  components: { Table },
  props: ['item', 'showDescID', 'type'],
  data() {
    return {
      isTableShow: false,
      isTableDescShow: false,
    };
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
    canConfirm() {
      return !this.$props.item.is_confirmed && this.$props.type !== 'archive';
    },
    isNeedSales() {
      return this.$props.item.need_sales;
    },
    isNeedPhotos() {
      return this.$props.item.need_photos;
    },
    showActionProgress() {
      return !!(this.$props.item.is_confirmed && !this.isNeedSales);
    },
    showActionPhotos() {
      return !!(this.isNeedPhotos || this.isNeedSales) && !this.canConfirm;
    },
    getStatusColor() {
      switch (this.$props.item.status) {
        case 'active': return '#35144b';
        case 'paid': return '#35144b';
        default: return '#35144b';
      }
    },
  },
  methods: {
    showPDF(url) {
      this.$emit('showPDF', url);
    },
    showDesc(id) {
      this.$emit('showDesc', id);
    },
    onTableShow() {
      this.isTableShow = !!(this.$props.item.original_sales_table && !this.isTableShow);
      this.isTableDescShow = !!(!this.$props.item.original_sales_table && !this.isTableDescShow);
    },
    confirmAction(id) {
      this.$store.dispatch('sales/ConfirmAction', {
        profile_id: this.user.profile_id,
        action_id: id,
      });
    },
    goToDetails() {
      this.$router.push(`/actions/${this.$props.item.id}`);
    },
  },
};
</script>

<style scoped lang="scss">
.actions {
  &__title {
    justify-content: space-between;

    @media all and (min-width: 600px) {
      flex-wrap: nowrap;
    }
  }

  &__status-dot {
    display: inline-block;
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background-color: #35144b;
    margin-right: 10px;

    &.active {
      background-color: #35144b;
    }

    &.paid {
      background-color: #35144b;
    }
  }

  &__desc-wrap {
    @media all and (min-width: 1024px) {
      display: flex;
      flex-direction: column-reverse;
    }
  }

  &__desc {
    padding-bottom: 20px;
    font-weight: 400;

    @media all and (min-width: 1024px) {
      padding: 0;
    }
  }

  &__bonuses {
    @media all and (min-width: 1024px) {
      text-transform: uppercase;
      color: #FF7F45;
      margin-bottom: 15px;
    }
  }
  .buttons-wrap{
    display: flex;
    margin: 0 -5px;
    width: calc(100% + 10px);
    &--button{
      width: auto;
      flex-grow: 1;
      margin: 0 5px;
    }
    @media all and (max-width: 1259px) {
      flex-direction: column;
      width: auto;
      margin: 0;
      &--button{
        margin: 0 0 10px;
      }
    }
    @media all and (max-width: 959px) {
      flex-direction: row;
      margin: 0 -5px;
      width: calc(100% + 10px);
      &--button{
        margin: 0 5px;
      }
    }
    @media all and (max-width: 576px) {
      flex-direction: column;
      width: auto;
      margin: 0;
      &--button{
        margin: 0 0 10px;
      }
    }
  }

}
</style>
